var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h4',{staticClass:"notAllowed text-center"},[_vm._v("La colección que intenta buscar no está disponible. Busque entre nuestras colecciones disponibles, en la pestaña colecciones del menú.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }